module.exports = __webpack_public_path__ + "static/media/gif-2.0d89f009.gif";